module.exports = __webpack_public_path__ + "img/logo-ecosmetagora.79a13bf5.png";